// extracted by mini-css-extract-plugin
export default {"heading":"PaymentOptions_heading__LVzQg","wrapper":"PaymentOptions_wrapper__ABl7C"};